import React, { useState } from "react";
import { CheckSVG, DashSVG } from "../../assets/svg/allSvg";

const PricingPlan = () => {
  const [showPopup, setShowPopup] = useState(false);

  const PlanContents = [
    "Listing on Naayatrade",
    "Customize Seller Dashboard",
    "Unlimited product listing",
    "SEO keywords",
    "Digital catalog",
    "Business verification support",
    "Dedicated accounts manager",
    "Trusted tag of Naayatrade",
    "Website - webstore front",
    "Business journey video-shoot",
    "Product's HD shoot",
    "Infographic images",

    "Infographic videos",
    "Creative",
    "PDF version of catalog",
    "Logistic support",
    "Payment integration",
    "Estimated leads",
    "Interactive Digital vCard",
    "SSL secure connection",
    "Sponsored banners",
    "Email booking",
    "Domain booking",
    "Super Naayatrade seller batch",
    "Personal web-application",
    "WhatsApp notification",
    "Email notification / SMS notification",
    "Regional Language operational view",
    "CRM+ LRM enhanced features",
    "Dedicated SEO Services",
    "Google adword worth",
  ];

  // Function to handle the click on "Select Plan" buttons
  const handleSelectPlan = () => {
    // Show the popup
    setShowPopup(true);
  };

  // Function to close the popup
  const closePopup = () => {
    setShowPopup(false);
  };

  // console.log(PlanContents);

  return (
    <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col pt-[36px] pl-[39px] pr-[17px] pb-[30px]">
      <div className="w-full flex items-center justify-between">
        <h3 className="w-[140px] h-[24px] text-black text-start font-semibold text-[16px]">
          Pricing plan
        </h3>
        <p className="w-[261px] font-medium text-[14px] text-black">
          Premium Plan expires on :{" "}
          <span className="text-[14px] font-semibold text-[#FF6300]">
            30/6/2024
          </span>
        </p>
      </div>
      <hr className="w-[167px] h-[3px] bg-[#FF6300] rounded-full mt-[9px]" />

      <div className="w-[958px] h-[692px] bg-white mt-[40px] rounded-[10px] pt-[27px] pl-[17px] pr-[38px] pb-[34px] flex flex-row drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] overflow-y-scroll">
        <div className="flex flex-col mt-[24px] w-[245px]">
          <h3 className="w-[90px] h-[24px] text-start font-semibold text-[18px] mb-[45px]">
            Features
          </h3>
          <ul className="list-disc space-y-[21px] font-medium text-black text-start text-[12px]">
            {PlanContents.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>

        <div className="w-[651px] flex items-start justify-end">
          <div className="w-[171px] h-[1410px] flex items-start">
            <div className="w-[171px] flex flex-col items-center justify-normal">
              <div className="flex flex-row items-center justify-between w-full mt-[24px]">
                <div className="gap-x-[7px] flex items-center">
                  <img
                    src={require("../../assets/SellerDashboard/PricingPlan/Basic.jpg")}
                    alt=""
                    className="w-[24px] h-[30px]"
                  />
                  <h4 className="w-[64px] h-[21px] text-black font-semibold text-[14px]">
                    Basic
                  </h4>
                </div>
                {/* <p className="w-[45px] text-end h-[21px] text-black font-semibold text-[14px]">
                ₹ 999
                <span className="font-regular text-[12px] text-black w-[46px] h-[18px]">
                  / month
                </span>
              </p> */}
                <p className="w-[60px] h-[44px] font-semibold text-[16px] text-black leading-[22px] text-end">
                  ₹ 2,999{" "}
                  <span className="font-medium text-[12px] text-black">
                    / month
                  </span>
                </p>
              </div>

              <div className="w-[171px] h-auto mt-[16px] [&>*:nth-child(odd)]:bg-[#F2F2F2] [&>*:nth-child(even)]:bg-white">
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  50
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  3 Pages
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  48 Images
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  48 Videos
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  120 - 200
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  Basic
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {DashSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  {CheckSVG}
                </p>
              </div>

              <button
                className="w-[154px] h-[39px] bg-[#FF6300] rounded-[5px] font-semibold text-white text-[14px] mt-[31px]"
                onClick={handleSelectPlan}
              >
                Select Plan
              </button>
            </div>
          </div>

          <div className="w-[57px] h-[1360px] flex items-center justify-center">
            <hr className="w-[1px] h-full bg-[#E3E3E3]" />
          </div>

          <div className="w-[171px] h-[1410px] flex items-start">
            <div className="w-[171px] flex flex-col items-center">
              <div className="flex flex-row items-center justify-between w-full mt-[24px]">
                <div className="gap-x-[7px] flex items-center">
                  <img
                    src={require("../../assets/SellerDashboard/PricingPlan/Premium.jpg")}
                    alt=""
                    className="w-[24px] h-[30px]"
                  />
                  <h4 className="w-[79px] h-[21px] text-black font-semibold text-[14px]">
                    Premium
                  </h4>
                </div>
                {/* <p className="w-[50px] text-end h-[21px] text-black font-semibold text-[14px]">
                ₹ 2999
              </p> */}
                <p className="w-[60px] h-[44px] font-semibold text-[16px] text-black leading-[22px] text-end">
                  ₹ 9,999{" "}
                  <span className="font-medium text-[12px] text-black">
                    / month
                  </span>
                </p>
              </div>

              <div className="w-[171px] h-auto mt-[16px] [&>*:nth-child(odd)]:bg-[#F2F2F2] [&>*:nth-child(even)]:bg-white">
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  250
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  6 Pages
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  120 Images
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  96 Videos
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  410 - 500
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  Enhanced
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  {CheckSVG}
                </p>
              </div>

              <button className="w-[154px] h-[39px] bg-[#C1C1C1] rounded-[5px] font-semibold text-white text-[14px] mt-[31px] cursor-not-allowed">
                Current Plan
              </button>
            </div>
          </div>

          <div className="w-[57px] h-[1360px] flex items-center justify-center">
            <hr className="w-[1px] h-full bg-[#E3E3E3]" />
          </div>

          <div className="w-[171px] h-[1410px] flex items-start">
            <div className="w-[171px] flex flex-col items-center">
              <div className="flex flex-row items-center justify-between w-full mt-[24px]">
                <div className="gap-x-[7px] flex items-center">
                  <img
                    src={require("../../assets/SellerDashboard/PricingPlan/Elite.jpg")}
                    alt=""
                    className="w-[24px] h-[30px]"
                  />
                  <h4 className="w-[72px] h-[21px] text-black font-semibold text-[14px]">
                    Enterprise
                  </h4>
                </div>
                {/* <p className="w-[50px] text-end h-[21px] text-black font-semibold text-[14px]">
                ₹ 9999
              </p> */}
                <p className="w-[65px] h-[44px] font-semibold text-[16px] text-black leading-[22px] text-end">
                  ₹ 19,999{" "}
                  <span className="font-medium text-[12px] text-black">
                    / month
                  </span>
                </p>
              </div>

              <div className="w-[171px] h-auto mt-[16px] [&>*:nth-child(odd)]:bg-[#F2F2F2] [&>*:nth-child(even)]:bg-white">
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  500
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  Unlimited
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  240 Images
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  120 Videos
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  520 - 600
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>{" "}
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  Pro
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center">
                  {CheckSVG}
                </p>
                <p className="w-[171px] h-[39px] flex items-center justify-center text-[14px] font-semibold">
                  {CheckSVG}
                </p>
              </div>

              <button
                className="w-[154px] h-[39px] bg-[#FF6300] rounded-[5px] font-semibold text-white text-[14px] mt-[31px]"
                onClick={handleSelectPlan}
              >
                Select Plan
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-[652px] h-[370px] bg-white rounded-[10px] flex items-center justify-center flex-col">
            <p className="w-[107px] h-[107px] bg-[#0097B2] rounded-full flex items-center justify-center">
              <svg
                width="60"
                height="46"
                viewBox="0 0 60 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.1983 42.8495C21.5731 43.477 20.6874 44 19.9059 44C19.1245 44 18.2388 43.4509 17.5876 42.8233L3 28.1805L7.63676 23.5261L19.932 35.868L52.4414 3L57 7.73278L22.1983 42.8495Z"
                  fill="white"
                  stroke="white"
                  stroke-width="3"
                />
              </svg>
            </p>
            <h3 className="w-[158px] h-[30px] text-black font-semibold text-[16px] mt-[28px]">
              Payment Complete
            </h3>
            <p className="w-[346px] h-[26px] text-center text-black font-semibold text-[14px] mt-[12px]">
              Your plan will start after the current plan expires.
            </p>
            <button
              className="w-[95px] h-[42px] bg-white rounded-[10px] font-medium text-[14px] text-black border mt-[33px]"
              onClick={closePopup}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingPlan;
